export default "__VITE_ASSET__B8Sj8X4s__"